/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Settings_Files_Active_Filters_SearchInputs */

const es_settings_files_active_filters_search = /** @type {(inputs: Settings_Files_Active_Filters_SearchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Búsqueda: "${i?.query}"`)
};

const en_settings_files_active_filters_search = /** @type {(inputs: Settings_Files_Active_Filters_SearchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Search: "${i?.query}"`)
};

/**
* | output |
* | --- |
* | "Search: \"{query}\"" |
*
* @param {Settings_Files_Active_Filters_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_active_filters_search = /** @type {((inputs: Settings_Files_Active_Filters_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Active_Filters_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_active_filters_search(inputs)
	return en_settings_files_active_filters_search(inputs)
});
export { settings_files_active_filters_search as "settings.files.active_filters.search" }